.copyTooltip {
  // transition: none — instant show/hide; don't set position (Honeycomb balloon must stay absolute)
  transition: none;
  min-width: 0;
  white-space: nowrap;
}

.copyButton {
  position: absolute;
  right: 0;
  bottom: calc(var(--hcr-input-height-desktop) / 2);
  transform: translate(25%, 50%);
  padding: var(--hcr-spacing-half);
  border: 1px solid var(--hcr-ui-primary-color);
  border-radius: var(--hcr-border-radius-1);
  background-color: var(--hcr-highlight-color);
  cursor: pointer;

  svg {
    fill: var(--hcr-ui-primary-dark-color);
  }

  &:disabled {
    cursor: not-allowed;

    svg {
      fill: var(--hcr-content-disabled-color);
    }
  }
}
